export default "__VITE_ASSET__DKHHnZAZ__"